import MonthlyStatementService from './monthlyStatementService';

export default MonthlyStatementService;
